  document.addEventListener("DOMContentLoaded", () => {
    const colorNames = {
      "#7c82d6": "Lavender Blue",
      "#e74994": "Pink",
      "#3dc16d": "Green",
      "#000000": "Black",
      "#8ba9c3": "Arctic Breeze",
      "#fffb1d": "Bright Yellow",
      "#e593ba": "Soft Pink",
      "#7bd959": "Lime Green",
      "#dd0e0e": "Red",
      "#fbf515": "Neon Yellow"
    };
    document.querySelectorAll(".cw-card__colors").forEach(wrapper => {
      const nameBox = wrapper.querySelector(".cw-card__color-name");
      if (!nameBox) return;

      wrapper.querySelectorAll(".cw-card__dot").forEach(dot => {
        dot.addEventListener("mouseover", () => {
          const hex = dot.dataset.color.toLowerCase();
          nameBox.textContent = colorNames[hex] || hex;
        });
        dot.addEventListener("mouseout", () => {
          nameBox.textContent = "";
        });
        dot.addEventListener("click", () => {
          const hex = dot.dataset.color.toLowerCase();
          nameBox.textContent = colorNames[hex] || hex;
        });
      });
    });
  });